<div class="alert alert-danger" *ngIf="noUser">
  No user found !
</div>
<div class="alert alert-success" *ngIf="userFound">
  Please select from user dropdown
</div>
<div class="alert alert-success" *ngIf="naacDetailsSuccess">
  Naac details saved successfully!
</div>
<div class="alert alert-success" *ngIf="naacDetailsUpdate">
  Naac details updated successfully!
</div>
<div class="alert alert-success" *ngIf="deleteSuccess">
  Banner image deleted successfully!
</div>
<div class="alert alert-success" *ngIf="naacNewsSuccess && saveNews">
  News saved successfully!
</div>
<div class="alert alert-success" *ngIf="naacResourceSuccess && saveResource">
  Resource saved successfully!
</div>
<div class="alert alert-success" *ngIf="naacReteamSuccess && saveReTeam">
  Naac committee member saved successfully!
</div>

<div class="alert alert-success" *ngIf="naacNewsSuccess && saveAndUpdateNews">
  News updated successfully!
</div>
<div class="alert alert-success" *ngIf="naacResourceSuccess && saveAndUpdateResource">
  Resource updated successfully!
</div>
<div class="alert alert-success" *ngIf="naacReteamSuccess && saveAndUpdateReTeam">
  Naac committee member updated successfully!
</div>
<!-- <div class="alert alert-success" *ngIf="diNaacSuccess && saveAndUpdateNaac">
  NAAC updated successfully!
</div> -->

<div class="alert alert-success" *ngIf="deleteNews">
  News deleted successfully!
</div>
<div class="alert alert-success" *ngIf="deleteResource">
  Resource deleted successfully!
</div>
<div class="alert alert-success" *ngIf="deleteRegional">
  Naac committee member deleted successfully!
</div>
<div class="alert alert-success" *ngIf="deleteAffinity">
  NAAC deleted successfully!
</div>

<div class="alert alert-danger" *ngIf="errorMessageResourceActive">{{errorMessageResource}}
</div>
<div class="alert alert-danger" *ngIf="errorMessageRegionalActive">{{errorMessageRegional}}
</div>
<div class="alert alert-danger" *ngIf="timeOutError">
  {{timeoutErrorMessage}}
</div>
<div class="alert alert-danger" *ngIf="errorMsgUploadSave">
  Uploading failed and data will not be saved!
</div>
<div class="alert alert-danger" *ngIf="errorMsgUploadSaveUpdate">
  Uploading failed and updated data will not be saved!
</div>
<div class="alert alert-danger" *ngIf="errorAffinity">
  {{affinityErrorMsg}}
</div>
<div class="alert alert-success" *ngIf="affinitySuccess">
  Affinity Details added successfully!
</div>
<div class="alert alert-success" *ngIf="affinityUpdate">
  Affinity Details updated successfully!
</div>
<div class="alert alert-success" *ngIf="naacPublishSuccess">
  NAAC published successfully!
</div>


<div class="di-container">

  <div>
    <h5>CREATE NAAC</h5>
  </div>

  <div class="col-md-3 divfloat margin-top">
    <ul class="nav flex-column nav-pills" role="tablist">
      <li class="nav-item">
        <a id="BannerImage" class="nav-link active" data-toggle="pill" href="#home" (click)="naacMaster()">NAAC
          Dashboard</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-toggle="pill" href="#menu4" (click)="naacDashboard()"
          [ngClass]="{'pointerDisable':naacId == 0}">NAAC Details</a>
      </li>
      <li class="nav-item">
        <a class="nav-link " data-toggle="pill" href="#menu1" (click)="naacNews()"
          [ngClass]="{'pointerDisable':naacId == 0}">Latest NAAC News</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-toggle="pill" href="#menu2" (click)="naacResource()"
          [ngClass]="{'pointerDisable':naacId == 0}"> NAAC Additional Resources</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-toggle="pill" href="#menu3" (click)="naacReTeam()"
          [ngClass]="{'pointerDisable':naacId == 0}">NAAC Board</a>
      </li>
    </ul>
  </div>

  <!-- Entering fields starts here -->
  <div class="tab-content divfloat col-md-8">

    <!-- Dashboard tab starts here -->
    <div id="home" class="container tab-pane active"><br>
      <form (ngSubmit)="onDashboardSubmit('Draft')" action="" name="naacDashboardForm" #myFormDashboard="ngForm"
        enctype="multipart/form-data">
        <div class="form-group" [ngClass]="{'disableSection': disableAffinity == true}">
          <label class="naacDashboard">Select Affinity <span class="star"> *</span></label>
          <ng-select placeholder="--Select Affinity--" [items]="affinityList" name="affinityList" id="bpgName"
            bindLabel="bpgName" bindValue="bpgId" [(ngModel)]="selectedBpg" class="affinity-folder"
            [ngClass]="{'disableSection':naacEdit == true}" required>

          </ng-select>
        </div>
        <div class="form-group">
          <label class="naacDate" for="naacDate">Established Date</label>
          <input placeholder=" Enter Affinity Established Date" bsDatepicker class="form-control-inline date-icon"
            id="naacDate" name="naacDate" [(ngModel)]="naacDate">
        </div>

        <div class="clear"></div>
        <div class="btn-div alignment">
          <button type="submit" name="naacDashboardForm" class="btn btn-danger margin-save" name="naacDashboardForm"
            data-toggle="modal" data-target="#myModal" [disabled]="(!myFormDashboard.valid) ">SAVE</button>


          <button type="button" class="btn btn-danger margin-save" name="naacDashboardForm"
            (click)="resetDashboard()">RESET</button>
        </div>
      </form>

    </div>
    <!-- Dashboard tab ends here -->
    <!-- News tab starts -->
    <div id="menu1" class="container tab-pane fade" [ngClass]="{'disableSection':naacId == 0}"><br>
      <form (ngSubmit)="onNewsSubmit()" action="" name="diNewsForm" #myFormNews="ngForm" enctype="multipart/form-data">
        <div class="form-group">
          <label class="sitelabel" for="newsTitle">News Title <span class="star"> *</span></label>
          <input type="text" class="form-control" id="newsTitle" name="newsTitle" [(ngModel)]="newsTitle"
            maxlength="200" placeholder="Enter news title" required autocomplete="off">
        </div>

        <div class="form-group">
          <label class="sitelabel" for="newsDesc">News Description </label>
          <textarea class="form-control" id="newsDesc" name="newsDesc" placeholder="Enter description" maxlength="500"
            rows="4" [(ngModel)]="newsDesc" autocomplete="off"></textarea>
        </div>

        <div class="form-group">
          <label class="sitelabel" for="newsLink">News Link </label>
          <input type="text " class="form-control" (keyup)="onLinkType($event,'news')" id="newsLink" name="newsLink"
            [(ngModel)]="newsLink" maxlength="200" placeholder="Enter link" autocomplete="off">

        </div>
        <div class="form-group">
          <label class="sitelabel bannerupload" for="userPic">News Image</label>

          <input #myInput type="file" class="form-control inputfile inputfile-6" id="newsImage" name="newsImage"
            maxlength="200" [(ngModel)]="newsImage" (change)="fileChangeEvent($event, 'newsImage')" accept="image/*">

          <label for="newsImage" class="label-overflow"><span id="filenamenewsImage" class="ellipsis">JPEG or
              PNG</span><strong><img *ngIf="!isUploadnaacLogoImage" alt="Angular Logo"
                src="assets/images/upload-button.png" /></strong></label>

          <a class="deleteButton delete-button-style zoom-in-style" (click)="removeFile()">
            <img src="assets/images/delete.png" class="image" alt="Angular Logo"></a>
          <textarea class="form-control base64textarea" id="base64textareanewsImage"></textarea>
        </div>
        <div class="form-group" *ngIf="isUploadnewsImage">
          <label class="sitelabel bannerupload" for="newsImage"></label>
          <div class="pull-left">
            <div class="loader_ajax_small" [hidden]="isLoadernewsImageStop"></div>
            <image-cropper [imageChangedEvent]="imageChangedEvent" [aspectRatio]="newsImageWidth/newsImageHeight" [maintainAspectRatio]="true"
              [resizeToWidth]=newsImageWidth [resizeToHeight]=newsImageHeight [onlyScaleDown]="true" format="png"
              (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady()"
              (loadImageFailed)="loadImageFailed()" [imageQuality]="92"></image-cropper>
          </div>
        </div>
        <div class="form-group" *ngIf="isLoadernewsImageStop">
          <label class="sitelabel bannerupload" for="newsImage"></label>
          <div class="pull-left">
            <a (click)="doneUploadedImage('newsImage')"><span class="uploadImageClass"><i
                  class="fa fa-check"></i>&nbsp;Done</span></a>
            &nbsp;&nbsp;<a (click)="cancelUploadedImage('newsImage')"><span class="uploadImageClass"><i
                  class="fa fa-close"></i>&nbsp;Cancel</span></a>
          </div>
        </div>
        <div class="main-section">
          <p class="errorMessage" *ngIf="uploadFileExtensionNewsImage"> Please upload files only in jpeg and png formats
          </p>
        </div>

        <!--Error message starts -->
        <div class="main-section">
          <p class="errorMessage" *ngIf="newsLinkValid"> Enter valid link</p>
        </div>

        <div class="clear"></div>
        <div class="btn-div alignment">
          <button type="submit" name="diNewsForm" class="btn btn-danger margin-save" name="form2" data-toggle="modal"
            *ngIf="saveNews" data-target="#myModal"
            [disabled]="!myFormNews.valid || newsLinkValid == true || uploadFileExtensionNewsImage">SAVE</button>
          <button type="submit" name="diNewsForm" class="btn btn-danger margin-save" *ngIf="saveAndUpdateNews"
            data-toggle="modal" data-target="#myModal"
            [disabled]="!myFormNews.valid || newsLinkValid == true || uploadFileExtensionNewsImage">SAVE AND
            UPDATE</button>
          <button type="button" class="btn btn-danger margin-save" name="diNewsForm" (click)="resetNews()"
            data-toggle="modal" data-target="#myModal">RESET</button>
        </div>
      </form>
    </div>
    <!-- News tab close -->
    <!-- Additional Resource tab starts here -->
    <div id="menu2" class="container tab-pane fade" [ngClass]="{'disableSection':naacId == 0}"><br>
      <form (ngSubmit)="onResourceSubmit()" action="" name="diResourceForm" #myFormResource="ngForm"
        enctype="multipart/form-data">
        <div class="form-group">
          <label class="selectFolder">Select Folder <span class="star"> *</span></label>
          <ng-select class="folder-size" placeholder="--Select Folder--" [items]="folderNameList" name="folderNameList"
            bindLabel="folderName" bindValue="folderId" [(ngModel)]="selectedFolder" required>
          </ng-select>
          <a class="manage-folder-link cursor"  data-toggle="modal" data-target="#myModal" (click)="navigateNaacFolder()">Manage Folder</a>
        </div>
        <div class="form-group">
          <label class="sitelabel" for="addResouceTitle">Resource Title <span class="star"> *</span></label>
          <input type="text" class="form-control" id="addResouceTitle" name="addResouceTitle"
            [(ngModel)]="addResouceTitle" maxlength="200" placeholder="Enter resource title" autocomplete="off"
            required>
        </div>

        <div class="form-group">
          <label class="sitelabel" for="additionalDesc">Description </label>
          <textarea class="form-control" id="additionalDesc" name="additionalDesc"
            placeholder="Enter additional resources description" maxlength="500" [(ngModel)]="additionalDesc" rows="4"
            autocomplete="off"></textarea>
        </div>

        <div class="form-group">
          <label class="sitelabel" for="UploadDocument">Upload Document<span class="star"> *</span></label>
          <input type="file" id="UploadDocument" (change)="onFileSelected($event)" onclick="value = null"
            name="UploadDocument" placeholder="Upload" class="form-control input-lg upload-icon hideInput">
          <label class="form-control input-lg upload-icon file-name-padding label-overflow" for="UploadDocument"><label
              class="docNameEllipsis resource-ellipsis">{{ResourcefileName}}</label>
          </label>
        </div>
        
        <div class="form-group">
          <label class="sitelabel" for="resourceOrder">File Order<span class="star"> *</span></label>
          <input type="number" class="form-control" id="resourceOrder" name="resourceOrder"
            onkeypress="return !((event.charCode == 46||event.charCode == 101||event.charCode == 69)) && (event.charCode >= 48 && event.charCode <= 57)"
            [(ngModel)]="resourceOrder" placeholder="Enter file order" required autocomplete="off">
        </div>
        <div class="main-section">
          <p class="errorMessage" *ngIf="fileSizeExtensionError">You can only upload the
            file of size less than 500 MB </p>
        </div>

        <div class="clear"></div>

        <div class="btn-div alignment">
          <button type="submit" name="diResourceForm" class="btn btn-danger margin-save" data-toggle="modal"
            data-target="#myModal"
            [disabled]="(!myFormResource.valid || isFileUploded == false )  || fileSizeExtensionError"
            *ngIf="saveResource">SAVE</button>
          <button type="submit" name="diResourceForm" class="btn btn-danger margin-save" *ngIf="saveAndUpdateResource"
            data-toggle="modal" data-target="#myModal"
            [disabled]="(!myFormResource.valid || isFileUploded == false )  || fileSizeExtensionError">SAVE AND
            UPDATE</button>
          <button type="button" class="btn btn-danger margin-save" name="diResourceForm" (click)="resetResource()"
            data-toggle="modal" data-target="#myModal">RESET</button>
        </div>
      </form>

    </div>
    <!-- Additional Resource tab ends here -->
    <!-- Regional Engagement Team tab starts -->
    <div id="menu3" class="container tab-pane fade" [ngClass]="{'disableSection':naacId == 0}"><br>
      <div class="search-section">
        <div class="search-tag"><input type="text" class="form-control placeholder-class-search width-class "
            maxlength="50" placeholder="Search by first name, last name and email id" [(ngModel)]="searchTerm"
            id="searchTerm" name="searchTerm" autocomplete="off" />
          <button type="button" class="btn btn-danger image-search" (click)="searchBy()">SEARCH</button>
        </div>
      </div>
      <form (ngSubmit)="onReTeamSubmit()" class="padding-class" onkeypress="return !(event.charCode == 13)" action=""
        name="diRegionalForm" #myFormReTeam="ngForm" enctype="multipart/form-data">


        <div class="form-group">
          <label class="sitelabel" for="userName">Name <span class="star"> *</span></label>
          <ng-select placeholder="Select user" name="userName" class="custom user-width" [items]="userList"
            [disabled]="noUser || butDisabled" bindLabel="userFirstName" Value="userId" [(ngModel)]="userFirstName"
            (change)="userSelection($event)" required>
              <ng-template ng-option-tmp let-item="item" let-index="index">
                <div>{{item.userFirstName}}</div>
                <div *ngIf="item.division" style="font-size: 11px">{{item.division}}</div>
                <div *ngIf="item.classification" style="font-size: 11px">{{item.classification}}</div>
              </ng-template>
          </ng-select>
        </div>

        <div class="form-group">
          <label class="sitelabel" for="regionalDesignation">Role Name <span class="star"> *</span></label>
          <input type="text" class="form-control" id="regionalDesignation" name="regionalDesignation"
            [(ngModel)]="regionalDesignation" placeholder="Enter role name" required autocomplete="off" maxlength="50">
        </div>
        <div class="form-group">
          <label class="sitelabel" for="emailId">Email Id <span class="star"> *</span></label>
          <input type="text" class="form-control" id="emailId" name="emailId" [(ngModel)]="emailId"
            [readonly]="noUser || butDisabled" (keyup)="onEmailType($event)" placeholder="Enter email id" required
            maxlength="50">
        </div>
        <div class="form-group">
          <label class="sitelabel" for="naacPronoun">Pronouns </label>
          <input type="text" class="form-control" id="naacPronoun" name="naacPronoun" [(ngModel)]="naacPronoun"
            placeholder="Enter Pronouns" maxlength="50">

        </div>
        <div class="form-group">
          <label class="sitelabel" for="siteName">Site </label>
          <ng-select placeholder="Select site" name="userName" class="custom user-width" [items]="siteList"
            bindLabel="siteName" Value="siteName" [(ngModel)]="siteName" multiple="true"></ng-select>
        </div>
        <div class="form-group">
          <label class="sitelabel bannerupload" for="userPic">Upload Image<span class="star"> *</span></label>
          <input #myInput type="file" class="form-control inputfile inputfile-6" id="userPic" name="userPic"
            maxlength="200" [(ngModel)]="userPic" (change)="fileChangeEvent($event, 'userPic')" accept="image/*"
            [required]="userPic == null" [attr.disabled]="isUploadUserPicImage == true ? true : null">
          <label for="userPic" class="label-overflow"><span id="filenameUserPic" class="ellipsis">JPEG or
              PNG</span><strong><img *ngIf="!isUploadUserPicImage" alt="Angular Logo"
                src="assets/images/upload-button.png" /></strong></label>
          <textarea class="form-control base64textarea" id="base64textareaUser"></textarea>
        </div>
        <div class="form-group" *ngIf="isUploadUserPicImage">
          <label class="sitelabel bannerupload" for="userPic"></label>
          <div class="pull-left">
            <div class="loader_ajax_small" [hidden]="isLoaderUserPicStop"></div>
            <image-cropper [imageChangedEvent]="imageChangedEvent" [aspectRatio]="400/400" [maintainAspectRatio]="true"
              [resizeToWidth]="400" [resizeToHeight]="400" [onlyScaleDown]="true" format="png"
              (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady()"
              (loadImageFailed)="loadImageFailed()" [imageQuality]="92"></image-cropper>
          </div>
        </div>
        <div class="form-group" *ngIf="isLoaderUserPicStop">
          <label class="sitelabel bannerupload" for="userPic"></label>
          <div class="pull-left">
            <a (click)="doneUploadedImage('userPic')"><span class="uploadImageClass"><i
                  class="fa fa-check"></i>&nbsp;Done</span></a>
            &nbsp;&nbsp;<a (click)="cancelUploadedImage('userPic')"><span class="uploadImageClass"><i
                  class="fa fa-close"></i>&nbsp;Cancel</span></a>
          </div>
        </div>
        <div class="form-group">
          <label class="sitelabel" for="reTeamOrder">Order<span class="star"> *</span></label>
          <input type="number" class="form-control" id="reTeamOrder" name="reTeamOrder"
            onkeypress="return !((event.charCode == 46||event.charCode == 101||event.charCode == 69)) && (event.charCode >= 48 && event.charCode <= 57)"
            [(ngModel)]="reTeamOrder" placeholder="Enter order" required autocomplete="off">
        </div>

        <div class="main-section">
          <p class="errorMessage" *ngIf="uploadFileExtensionUser"> You can only upload jpg, jpeg, png files</p>
          <p class="errorMessage" *ngIf="reTeamEamilValid"> Enter valid email</p>

        </div>

        <div class="clear"></div>

        <div class="btn-div alignment">
          <button type="submit" id="saveReTeam" name="diRegionalForm" class="btn btn-danger margin-save"
            [disabled]="!myFormReTeam.valid || reTeamEamilValid  || uploadUserPicImageDone || uploadFileExtensionUser"
            *ngIf="saveReTeam">SAVE</button>
          <button name="diRegionalForm" id="UpdateReTeam" class="btn btn-danger margin-save" *ngIf="saveAndUpdateReTeam"
            [disabled]="!myFormReTeam.valid || reTeamEamilValid || uploadUserPicImageDone || uploadFileExtensionUser">SAVE
            AND UPDATE</button>
          <button type="button" class="btn btn-danger margin-save" name="diRegionalForm" (click)="resetReTeam()"
            data-toggle="modal" data-target="#myModal">RESET</button>
        </div>
      </form>
    </div>
    <!-- Regional Engagement Team tab ends -->
    <!-- Naac Dashboard tab starts -->
    <div id="menu4" class="container tab-pane fade" [ngClass]="{'disableSection':naacId == 0}"><br>
      <form (ngSubmit)="onNaacMasterSubmitBanner()" action="" name="diMasterForm" #myFormMaster="ngForm"
        enctype="multipart/form-data">
        <div class="form-group">
          <label class="sitelabel" for="UploadDocument">Banner Image<span class="star"> *</span>
          </label>
          <input type="file" id="diBanner" (change)="onFileSelectedBanner($event)" name="diBanner"
            placeholder="JPEG or PNG" class="form-control input-lg upload-icon hideInput">
          <label class="form-control input-lg upload-icon file-name-padding label-overflow" for="diBanner"><label
              class="docNameEllipsis resource-ellipsis">{{uploadFileNameBanner}}</label>
            <!-- <textarea class="form-control base64textarea" id="base64textareaBanner"></textarea> -->
          </label>
        </div>

        <div class="form-group" *ngIf="isUploadBannerImage && !bannerImageExtensionError">
          <label class="sitelabel bannerupload" for="userPic"></label>
          <div class="pull-left">
            <div class="loader_ajax_small" [hidden]="isLoaderBannerStop"></div>
            <image-cropper [imageChangedEvent]="imageChangedEventBanner" [aspectRatio]="1366/500"
              [maintainAspectRatio]="true" [resizeToWidth]="1366" [resizeToHeight]="500" [onlyScaleDown]="true"
              (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady()"
              (loadImageFailed)="loadImageFailed()" [imageQuality]="100"></image-cropper>
          </div>
        </div>
        <div class="form-group" *ngIf="isLoaderBannerStop && !bannerImageExtensionError">
          <label class="sitelabel bannerupload" for="userPic"></label>
          <div class="pull-left">
            <a (click)="doneUploadedImage('bannerImage')"><span class="uploadImageClass"><i
                  class="fa fa-check"></i>&nbsp;Done</span></a>
            &nbsp;&nbsp;<a (click)="cancelUploadedImage('bannerImage')"><span class="uploadImageClass"><i
                  class="fa fa-close"></i>&nbsp;Cancel</span></a>
          </div>
        </div>
        <div class="main-section">
          <p class="errorMessage" *ngIf="bannerImageExtensionError"> Please upload files only in jpeg and png formats
          </p>
        </div>

        <div class="form-group">
          <label class="sitelabel bannerupload" for="userPic">NAAC Logo<span class="star"> *</span></label>

          <input #myInput type="file" class="form-control inputfile inputfile-6" id="naacLogo" name="naacLogo"
            maxlength="200" [(ngModel)]="naacLogo" (change)="fileChangeEvent($event, 'naacLogo')" accept="image/*"
            [required]="naacLogo == null" [attr.disabled]="isUploadnaacLogoImage == true ? true : null">
          <label for="naacLogo" class="label-overflow"><span id="filenamenaacLogo" class="ellipsis">JPEG or
              PNG</span><strong><img *ngIf="!isUploadnaacLogoImage" alt="Angular Logo"
                src="assets/images/upload-button.png" /></strong></label>
          <textarea class="form-control base64textarea" id="base64textareanaacLogo"></textarea>
        </div>
        <div class="form-group" *ngIf="isUploadnaacLogoImage">
          <label class="sitelabel bannerupload" for="naacLogo"></label>
          <div class="pull-left">
            <div class="loader_ajax_small" [hidden]="isLoaderNaacLogoStop"></div>
            <image-cropper [imageChangedEvent]="imageChangedEvent" [aspectRatio]="400/400" [maintainAspectRatio]="true"
              [resizeToWidth]="400" [resizeToHeight]="400" [onlyScaleDown]="true" format="png"
              (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady()"
              (loadImageFailed)="loadImageFailed()" [imageQuality]="92"></image-cropper>
          </div>
        </div>
        <div class="form-group" *ngIf="isLoaderNaacLogoStop">
          <label class="sitelabel bannerupload" for="naacLogo"></label>
          <div class="pull-left">
            <a (click)="doneUploadedImage('naacLogo')"><span class="uploadImageClass"><i
                  class="fa fa-check"></i>&nbsp;Done</span></a>
            &nbsp;&nbsp;<a (click)="cancelUploadedImage('naacLogo')"><span class="uploadImageClass"><i
                  class="fa fa-close"></i>&nbsp;Cancel</span></a>
          </div>
        </div>
        <div class="main-section">
          <p class="errorMessage" *ngIf="uploadFileExtensionnaacLogo"> Please upload files only in jpeg and png formats
          </p>
        </div>
        <div class="form-group">
          <label class="statement label-width" name="visionStmt" id="vision-lbl">Vision Statement
            <span class="star"> *</span>
            <label class="validation-error-message" *ngIf="naacVision != null && naacVision.length>=1024">
              Only a maximum of 1024 characters are allowed
            </label>
          </label>
          <div class="ckeditor-style val-margin">
            <ckeditor [(ngModel)]="naacVision" #myckeditor="ngModel" name="naacVision" maxlength="1024"
              [config]="removeToolbar" [readonly]="false" required>
            </ckeditor>
          </div>

        </div>
        <div class="form-group">
          <label class="statement label-width" name="naacAffinity" id="vision-lbl">Affinity Goals
            <span class="star"> *</span>
            <label class="validation-error-message" *ngIf="naacAffinity != null && naacAffinity.length>=1024">
              Only a maximum of 1024 characters are allowed
            </label>
          </label>
          <div class="ckeditor-style val-margin">
            <ckeditor [(ngModel)]="naacAffinity" #myckeditor="ngModel" name="naacAffinity" maxlength="1024"
              [config]="removeToolbar" [readonly]="false" required>
            </ckeditor>
          </div>

        </div>
        <div class="btn-div alignment">
          <button type="submit" name="diMasterForm" class="btn btn-danger margin-save" data-toggle="modal"
            data-target="#myModal"
            [disabled]="(bannerImageExtensionError || !isbannerimageLoaded || !myFormMaster.valid || uploadnaacLogoDone || uploadFileExtensionnaacLogo) ">SAVE
          </button>
          <button type="button" class="btn btn-danger margin-save" name="diMasterForm" (click)="resetnaacDetails()"
            data-toggle="modal" data-target="#myModal">RESET</button>
          <!-- <p class="noDataFound text-center" *ngIf="noDataFound"> No data found </p> -->
          <div>
            <div id="tabledemo1" class="table-contents">
              <div class="table-container1">
                <div class="top-margin">

                </div>
              </div>

            </div>
          </div>
        </div>
      </form>

      <!-- Naac Dashboard tab ends -->

    </div>

    <div class="clear"></div>

    <app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param,param1)" id="2"></app-confirmation-modal>
  </div>
  <!-- </form> -->
  <div class="outer-div" *ngIf="naacNewsTable == true">
    <div class="searchBox">
      <label for="search">Search</label>
      <input type="text" class="form-control" id="newsSearchKey" maxlength="50" placeholder="Search by news title"
        [(ngModel)]="newsSearchKey" (keyup.enter)="searchNewsMe()" autocomplete="off">
    </div>
  </div>
  <div class="outer-div" *ngIf="naacResourceTable == true">
    <div class="searchBox">
      <label for="search">Search</label>
      <input type="text" class="form-control" id="resourceSearchKey" maxlength="50"
        placeholder="Search by resource title" [(ngModel)]="resourceSearchKey" (keyup.enter)="searchResourceMe()"
        autocomplete="off">
    </div>
  </div>

  <div class="outer-div" *ngIf="naacReTeamTable == true">
    <div class="searchBox">
      <label for="search">Search</label>
      <input type="text" class="form-control placeholder-class-search" id="reTeamSearchKey" maxlength="50"
        placeholder="Search by name, role name and email id" [(ngModel)]="reTeamSearchKey"
        (keyup.enter)="searchReTeamMe()" autocomplete="off">
    </div>
  </div>
  <!-- <div class="outer-div" *ngIf="diNaacTable == true">
    <div class="searchBox">
      <label for="search">Search</label>
      <input type="text" class="form-control" id="naacSearchKey" maxlength="50" placeholder="Search by affiliate name"
        [(ngModel)]="naacSearchKey" (keyup.enter)="searchNaacMe()" autocomplete="off">
    </div>
  </div> -->


  <!-- table for affinity table -->
  
  <div id="home" class="table-padding" *ngIf=" affinityTable">
    
    <div class="table-container horizontal-scroll">
      <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo">
        <thead>
          <tr class="tr-th">
            <th scope="col">NAAC</th>
            <th scope="col">Status</th>
            <th scope="col" class="text-center">Actions</th>

          </tr>
        </thead>
        <tbody>
         
          <tr
            *ngFor="let data of naacAffinityList  | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements },let i = index">
            <td class="news-ellipsis">{{data.naacAffinityName}}</td>
            <td class="news-ellipsis" *ngIf="(data.naacCheck == 'false')">Draft</td>
            <td class="news-ellipsis" *ngIf="(data.naacCheck == 'true' && data.naacStatus != 'Publish')">Draft <span
                class="draft-publish">(Ready to be published) </span></td>
            <td class="news-ellipsis" *ngIf="(data.naacCheck == 'true' && data.naacStatus == 'Publish')">Published</td>
            <td class="affinityIcon">

              <a class="cloneButton" id="editN{{i}}" title="Edit" (click)="editNaac(data)" data-toggle="modal"
                data-target="#myModal">
                <img src="assets/images/edit.png" class="image" alt="Angular Logo">
              </a>
              <a class="cloneButton" id=deleteNaac{{i}} title="Delete" data-toggle="modal" data-target="#myModal"
                (click)="OnnaacDeleteConfirmation(data.naacId)">
                <img src="assets/images/delete.png" class="image" alt="Angular Logo">
              </a>
              <a class="cloneButton" title="Publish" *ngIf="(data.naacCheck == 'true' && data.naacStatus != 'Publish')"
                data-toggle="modal" data-target="#myModal" (click)="onPublishNaac(data,'Publish')">
                <img src="assets/images/event_report.png" class="image" alt="Angular Logo">
              </a>

            </td>
          </tr>

        </tbody>
      </table>
      <p class="noDataFound" *ngIf="noAffinityTable"> No NAAC data found </p>
    </div>

    <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
      <span>Showing {{currentShowingElementsAffinity}} of {{numberOfElements}} results</span>
      <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageAffinityChanged($event)">
      </pagination-controls>
    </div>
  </div>

  <!-- table for di news -->
 
  <div id="menu1" class="table-padding" *ngIf=" naacNewsTable">
    <div class="table-container horizontal-scroll">
      <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo">
        <thead>
          <tr class="tr-th">
            <th scope="col">News Title</th>
            <th scope="col">News Link</th>
            <th scope="col" class="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let data of selectedNews  | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements },let i = index">
            <td class="news-ellipsis">{{data.naacNewsTitle}}</td>
            <td class="news-ellipsis">{{data.naacNewsLink}}</td>

            <td>
              <a id="editN{{i}}" (click)="editNews(data,i)" class="edit-delete"><img src="assets/images/edit.png"
                  class="image" title="Edit" alt="Angular Logo"></a>
              <a class="edit-delete" id=deleteNaac{{i}} (click)="deleteNaac(data.naacNewsId,'news',i)"><img
                  src="assets/images/delete.png" class="image" title="Delete" alt="Angular Logo"></a>
            </td>
          </tr>

        </tbody>
      </table>
     
      <p class="noDataFound" *ngIf="noNewsTable && isNewsPageClicked"> No News Found </p>
    </div>

    <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
      <span>Showing {{currentShowingElementsNews}} of {{numberOfElements}} results</span>
      <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageNewsChanged($event)">
      </pagination-controls>
    </div>
  </div>

  <!-- table for di resource -->
 
  <div id="menu2" class="table-padding" *ngIf=" naacResourceTable">
    
    <div class="table-container horizontal-scroll">
      
      <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo">
        <thead>
          
          <tr class="tr-th">
            <th scope="col">File Order</th>
            <th scope="col">Resource Title</th>
            <th scope="col">Folder Order</th>
            <th scope="col">Folder Name</th>
            <th scope="col" class="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
         
          <tr
            *ngFor="let data of selectedResource  | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements },let i = index">
            <td>{{data.resourceOrder}}</td>

            <td>{{data.naacResourceTitle}}</td>
            <td class="folderorder">{{data.folderOrder}}</td>
            <td>{{data.folderName}}</td>

            <td>
              <a id="editR{{i}}" (click)="editResource(data,i)" class="edit-delete"><img src="assets/images/edit.png"
                  class="image" title="Edit" alt="Angular Logo"></a>
              <a class="edit-delete" id=deleteNaac{{i}} (click)="deleteNaac(data.naacResourceId,'resource',i)"><img
                  src="assets/images/delete.png" class="image" title="Delete" alt="Angular Logo"></a>
            </td>
          </tr>
         
        </tbody>
        
      </table>
      
      <p class="noDataFound" *ngIf="noResourceTable && isResourcePageClicked"> No Resource found </p>
    </div>

    <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
      <span>Showing {{currentShowingElementsResource}} of {{numberOfElements}} results</span>
      <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageResourceChanged($event)">
      </pagination-controls>
    </div>
  </div>
 
  <div id="menu3" class="table-padding" *ngIf=" naacReTeamTable">
    
    <div class="table-container horizontal-scroll">
      <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo">
        <thead>
          <tr class="tr-th">

            <th scope="col">Order</th>
            <th scope="col">Name</th>
            <th scope="col">Role Name</th>
            <th scope="col">Email Id</th>

            <th scope="col" class="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let data of selectedReteam  | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements },let i = index">
            <td>{{data.regionalOrder}}</td>
            <td>{{data.userName}}</td>
            <td>{{data.roleName}}</td>
            <td>{{data.emailId}}</td>
            <td class="col-display">{{data.naacReTeamId}}</td>

            <td>
              <a id="editRt{{i}}" (click)="editReTeam(data,i)" class="edit-delete"><img src="assets/images/edit.png"
                  class="image" title="Edit" alt="Angular Logo"></a>
              <a class="edit-delete" id=deleteNaac{{i}} (click)="deleteNaac(data.naacReTeamId,'regional',i)"><img
                  src="assets/images/delete.png" class="image" title="Delete" alt="Angular Logo"></a>
            </td>
          </tr>

        </tbody>
      </table> 

      <p class="noDataFound" *ngIf="noReginalTbale && isRegionalPageClicked"> No NAAC Member found </p>
    </div>

    <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
      <span>Showing {{currentShowingElementsReTeam}} of {{numberOfElements}} results</span>
      <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageReteamChanged($event)">
      </pagination-controls>
    </div>
  </div>


  



